import type { FetcherArgs } from '@ricoh/ria.client.core/plugins/swr/fetcher';
import type { Func } from '@ricoh/ria.client.core/types/core/function.type';
import type { Middleware, SWRHook } from 'swr';

/**
 * Create Session middleware.
 *
 * @param {Func} resetSession Reset session.
 *
 * @returns {Middleware} Session middleware.
 */
export function createSessionMiddleware(resetSession: Func): Middleware {
  return (useSWRNext: SWRHook): ReturnType<Middleware> =>
    (key, fetch, options) => {
      if (!fetch) {
        return useSWRNext(key, fetch, options);
      }

      const fetchWithSessionReset = async (...args: FetcherArgs) => {
        const response = await fetch(...args);
        resetSession();
        return response;
      };

      return useSWRNext(key, fetchWithSessionReset, options);
    };
}
